module.exports = __webpack_public_path__ + "static/media/Group 27128.436a18b1.svg";